import React from "react";
import { WellLimit } from "../../../Model/PlateType";
import SwitchButton from "./../../Buttons/SwitchButton";
import TextBox from "./../../Common/TextBox";
import "./WellLimitsTabView.css";

type Props = {
  wellLimit: WellLimit;
  setWellLimit: (wellLimit: WellLimit) => void;
  wellLimitEnabled: boolean;
  setWellLimitEnabled: (enabled: boolean) => void;
};

const WellLimitstabView = ({ wellLimit, setWellLimit, wellLimitEnabled, setWellLimitEnabled }: Props) => {
  var btnToggle = (isOn: boolean) => {
    setWellLimitEnabled(!isOn);
  };

  return (
    <div className="well-limit-container">
      <div className="well-limit-switch">
        <span>Disable Well Limits </span>
        <SwitchButton isOn={!wellLimitEnabled} onToggle={btnToggle} />
      </div>
      <table className="well-limit-table">
        <tbody>
          <tr>
            <td>X</td>
            <td>Min </td>
            <td>
              <TextBox
                name="XMin"
                value={wellLimit.min.x}
                onChange={(value) => {
                  setWellLimit({
                    ...wellLimit,
                    min: {
                      ...wellLimit.min,
                      x: value as number,
                    },
                  });
                }}
                isInteger={false}
                variant="number"
              />
            </td>
            <td>Max </td>
            <td>
              <TextBox
                name="XMax"
                value={wellLimit.max.x}
                onChange={(value) => {
                  setWellLimit({
                    ...wellLimit,
                    max: {
                      ...wellLimit.max,
                      x: value as number,
                    },
                  });
                }}
                isInteger={false}
                variant="number"
              />
            </td>
          </tr>
          <tr>
            <td>Y</td>
            <td>Min </td>
            <td>
              <TextBox
                name="YMin"
                value={wellLimit.min.y}
                onChange={(value) => {
                  setWellLimit({
                    ...wellLimit,
                    min: {
                      ...wellLimit.min,
                      y: value as number,
                    },
                  });
                }}
                isInteger={false}
                variant="number"
              />
            </td>
            <td>Max </td>
            <td>
              <TextBox
                name="YMax"
                value={wellLimit.max.y}
                onChange={(value) => {
                  setWellLimit({
                    ...wellLimit,
                    max: {
                      ...wellLimit.max,
                      y: value as number,
                    },
                  });
                }}
                isInteger={false}
                variant="number"
              />
            </td>
          </tr>
          <tr>
            <td>Z</td>
            <td>Min </td>
            <td>
              <TextBox
                name="ZMin"
                value={wellLimit.min.z}
                onChange={(value) => {
                  setWellLimit({
                    ...wellLimit,
                    min: {
                      ...wellLimit.min,
                      z: value as number,
                    },
                  });
                }}
                isInteger={false}
                variant="number"
              />
            </td>
            <td>Max </td>
            <td>
              <TextBox
                name="ZMax"
                value={wellLimit.max.z}
                onChange={(value) => {
                  setWellLimit({
                    ...wellLimit,
                    max: {
                      ...wellLimit.max,
                      z: value as number,
                    },
                  });
                }}
                isInteger={false}
                variant="number"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="well-limit-note">
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7778 9C18.7778 13.9706 14.7484 18 9.77783 18C4.80727 18 0.777832 13.9706 0.777832 9C0.777832 4.02944 4.80727 0 9.77783 0C14.7484 0 18.7778 4.02944 18.7778 9ZM8.49213 6.85713H11.0636V14.5714H8.49213V6.85713ZM11.0636 3.42856H8.49216V5.99999H11.0636V3.42856Z"
            fill="#2F80ED"
          />
        </svg>

        <p>
          Please note that by default well limits will always be enabled. Applying changes on this tab will save the
          well limit value changes, but the limit will always be turned on.
        </p>
      </div>
    </div>
  );
};

export default WellLimitstabView;
